import conf from 'src/conf/conf';
import userManager from 'src/auth/userManager';
import { merge } from 'ramda';
import { I18n } from 'src/translations/i18n';
const JSON_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
export function getHeaders(customHeaders = {}) {
    return userManager.getUser()
        .then((user) => merge(JSON_HEADERS, {
        Authorization: `Bearer ${user?.access_token}`,
        ...(I18n.language?.iso6391 ? { 'accept-language': I18n.language.iso6391 } : {}),
        ...customHeaders
    }))
        .catch(() => JSON_HEADERS);
}
export async function getRequestConfig({ url, method = 'get', data = {}, getParams = '', responseType, api = conf.api, abortController, headers: customHeaders = {} }) {
    const headers = await getHeaders(customHeaders);
    const requestUrl = api + url + getParams;
    return {
        method,
        url: requestUrl,
        responseType,
        data,
        headers,
        signal: abortController?.signal
    };
}
